import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { Logger } from '@core/logger'
import { PullingTimeout } from '@core/query'
import { convertAudioTranscodingSimple } from '@core/converters'
import { AudioQueryKey } from '@features/audio'

import { getSourceTranscodings } from '../services/getSourceTranscodings'

type TUseSourceTranscodingsOptions = {
    /** Poll until the source has a playable transcoding (a freshly uploaded one appears empty first). */
    pollUntilReady?: boolean
}

export const useSourceTranscodings = (
    sourceId: string,
    { pollUntilReady = false }: TUseSourceTranscodingsOptions = {},
) => {
    const query = useQuery({
        queryKey: AudioQueryKey.sourceTranscodings(sourceId),
        queryFn: async ({ signal }) => {
            const apiTranscodings = await getSourceTranscodings(sourceId, { signal })

            return apiTranscodings.map(convertAudioTranscodingSimple)
        },
        enabled: Boolean(sourceId),
        refetchInterval: pollUntilReady
            ? ({ state }) =>
                  state.data?.some(transcoding => transcoding.url !== '')
                      ? false
                      : PullingTimeout.Default
            : false,
    })

    useEffect(() => {
        if (query.error) {
            Logger.error('GET source transcodings error:', {
                error: query.error,
                sourceId,
            })
        }
    }, [query.error, sourceId])

    return query
}
